import { Box, Button } from '@mui/material';
import DataMigration from './DataMigration';
import { useAppSelector, useKabamFetchData } from '../../app/hooks';

const DataAdmin = () => {
  const kabamFetchData = useKabamFetchData();
  const loading = useAppSelector((state) => state.data.status === 'loading');

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box>
        <Button
          onClick={() => kabamFetchData()}
          disabled={loading}
          variant="contained"
        >
          Reload blueprints data
        </Button>
      </Box>
      <DataMigration />
    </Box>
  );
};

export default DataAdmin;
